define('bindingHandlers/csvList',[
    'jquery',
    'lib/lodash4',
    'util/keyCode',
    'lib/knockout'
], function ($, _, kc, ko) {
    'use strict';
    var TYPE_NUMBER = "number";
    var EVENT_NAMESPACE = ".csvListProxy-event";

    /**
     * Read a CSV input and converts it to array and assigns the array to the target observable
     * @param targetObsv Target Observable Array
     * @param type type of the array entry possible values(number, string)
     * @param e Event fired - Focus Out
     */
    var read = function(e) {
        var content = $(e.currentTarget).text();
        if (!e.data || e.data.type===null || !e.data.targetObsv){
            return; //Do nothing if values are not in event
        }
        var type = e.data.type;
        var targetObsv = e.data.targetObsv;

        if (!content.split || content.length===0) {
            targetObsv([]);
            return;
        }

        var listArray = _.without(content.split(','),null,""); // Remove any empty strings or null
        listArray = _.map(listArray,function(entry){
            var item = (entry.toString()).trim();
            item = (type===TYPE_NUMBER && !isNaN(entry))? Number(entry) : item;
            return item;
        });
        targetObsv(listArray);
    };

    /**
     * Write the array to the screen for the user. It converts the Array to a CSV format on the screen
     * @param listValue Target Observable containing value to be written to input field
     * @param element HTML element where to write converted array
     */
    var write = function(listValue, element) {
        var modifiedInput = '';
        _.each(listValue, function (entry,index) {
            var item = (entry.toString()).trim();
            if (index!==0){
                modifiedInput+=", ";
            }
            modifiedInput+= "<span>"+item+"</span>";
        });
        $(element).html(modifiedInput);
    };

    /**
     * Handles user key events to prevent default behaviors on selected keys
     */
    var handleKey = function(e){
        if (e.which===kc.ENTER){
            e.preventDefault();
        }
    };

    /**
     * Cleanup method for when the element's DOM is removed.
     */
    var onDisposal = function ($element) {
        // clean up events
        $element.off(EVENT_NAMESPACE);
    };

    /**
     * Ensures that when field gets focus the entire content is selected
     */
    var adjustSelection = function (e) {
        var element = e.currentTarget;
        var selection = document.getSelection();
        selection.removeAllRanges();
        var ranges = document.createRange();
        ranges.selectNodeContents(element);
        selection.addRange(ranges);
    };

    /**
     * <p>CSV List Proxy Binding</p>
     * <p>
     * This binding serves as a proxy for a CSV delimited list input field
     *  1) It takes the coma delimited field (READ) and converts it to an array of numbers and stores it in the target Observable array
     *  2) It takes value of the Observable Array and displays (WRITE) the array as a comma delimited field on the screen.
     *
     *  Binding example: data-bind="csvListProxy: {list: site().informationNumbers, type:'number'}"
     *    where list is the observable containing the list value
     *    and type determines the type of the entries in the list array. Possible values: string or number
     * </p>
     * @exports bindingHandlers/dropdown
     */
    ko.bindingHandlers.csvList = {
        init: function (element, valueAccessor) {
            var $element = $(element);
            var prop = ko.unwrap(valueAccessor());
            var type = (prop.type)? prop.type : TYPE_NUMBER;
            var targetObsv  = prop.list;
            //Add classes and attributes
            $element.attr('contenteditable','true').attr('spellcheck','false').addClass('csv-list');
            //Setup events
            $element.on('focusout'+EVENT_NAMESPACE,{targetObsv: targetObsv, type: type },read);
            $element.on('keydown'+EVENT_NAMESPACE,handleKey);
            $element.on('focus'+EVENT_NAMESPACE, adjustSelection);
            // Clean up the binding handler when the element is removed from the DOM.
            ko.utils.domNodeDisposal.addDisposeCallback(element, onDisposal.bind(null,$element));
        },
        update: function(element, valueAccessor){
            var prop = ko.unwrap(valueAccessor());
            var listValue = _.without(prop.list(),null,""); // Remove any empty strings or null
            write(listValue, element);
        }
    };
});

